<mat-dialog-content>
    <h2>Garbage Collector statistic</h2>
    <app-garbage-collector-statistic [garbageCollectorStatistic]="data"></app-garbage-collector-statistic>
</mat-dialog-content>
<mat-dialog-actions class="right">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>